import { gql } from '@apollo/client';

export const GET_DRAFT_BY_ID = gql`
    query getDraftById($id: String!) {
        getDraftById(id: $id) {
            hasStoryAnalysis
            storyAnalysis
            id 
            status
            categories
            textBlocks {
                id
                type
                data {
                    paragraph
                    header
                    level
                    items {
                        id
                        text
                    }
                    file {
                        url
                    }
                    code
                    withBorder
                    withBackground
                    stretched
                    caption
                    style
                }
            }
            textBlocksVersions {
                blocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
                id
            }
            article
            createdAt
            updatedAt
        }
    }
`;
